import { z } from 'zod'

import { viewUiDimensionCandidateSchema } from '../ui/dimension.ts'

export const viewConfigDimensionSchema = viewUiDimensionCandidateSchema
// export const viewConfigDimensionSchema = viewUiDimensionCandidateSchema.merge(z.object({
//   dateSpan: timeframeSchema.optional(), // 日付のフィールドをどうグルーピングするか
//   // numericSpan: z.number().array().optional(), // 数値のフィールドをどうグルーピングするか
// }))
export type ViewConfigDimension = z.infer<typeof viewConfigDimensionSchema>

export interface PieChartAggregation {
  chartFormat: 'pie'
  breakdown: ViewConfigDimension
  category?: ViewConfigDimension
}

export interface ComboChartAggregation {
  chartFormat: 'combo'
  xAxis: ViewConfigDimension
  breakdown?: ViewConfigDimension
}

export type ChartFormat = 'pie' | 'combo'

export type ChartAggregation = PieChartAggregation | ComboChartAggregation

const chartLabelDisplayModeSchema = z.enum(['auto', 'none', 'showAll'])
const chartLegendsDisplayModeSchema = z.enum(['auto', 'none', 'show'])
const chartValueLabelUnitTypeSchema = z.enum([
  'noUnit',
  'unitThousand',
  'unitMillion',
  'unitTenThousand',
  'unitHandredMillion',
])
const chartValueLabelDecimalPlaceTypeSchema = z.enum([
  'automatic',
  'noDecimalPlace',
  'firstDecimalPlace',
  'secondDecimalPlace',
  'thirdDecimalPlace',
  'fourthDecimalPlace',
])
const stackedChartTypeSchema = z.enum(['bar', 'line', 'area'])

const pieChartDesignSchema = z
  .object({
    chartValueLabelDisplayMode: chartLabelDisplayModeSchema.optional(),
    chartValueLabelUnitType: chartValueLabelUnitTypeSchema.optional(),
    chartValueLabelDecimalPlaceType: chartValueLabelDecimalPlaceTypeSchema.optional(),
    chartLegendsDisplayMode: chartLegendsDisplayModeSchema.optional(),
  })
  .strict()

const pieChartAggregationSchema = z
  .object({
    breakdown: viewConfigDimensionSchema,
    category: viewConfigDimensionSchema.optional(),
  })
  .strict()

const comboChartDesignSchema = z
  .object({
    chartType: stackedChartTypeSchema.optional(),
    chartValueLabelDisplayMode: chartLabelDisplayModeSchema.optional(),
    chartValueLabelUnitType: chartValueLabelUnitTypeSchema.optional(),
    chartValueLabelDecimalPlaceType: chartValueLabelDecimalPlaceTypeSchema.optional(),
    chartValueLabelShouldShowPercentage: z.boolean().optional(),
    chartAxisLabelDisplayMode: chartLabelDisplayModeSchema.optional(),
    chartLegendsDisplayMode: chartLegendsDisplayModeSchema.optional(),
  })
  .strict()

const comboChartAggregationSchema = z
  .object({
    xAxis: viewConfigDimensionSchema,
    breakdown: viewConfigDimensionSchema.optional(),
  })
  .strict()

// 入力バリデーション用 discriminated union（chartFormat 含む）
// chartFormat は DB カラムと settings JSON の両方に保存する（JSON 単独でスキーマを判別可能にするため）
export const kpiChartDisplaySettingPresetInputSchema = z.discriminatedUnion('chartFormat', [
  z
    .object({
      chartFormat: z.literal('pie'),
      aggregation: pieChartAggregationSchema,
      design: pieChartDesignSchema,
    })
    .strict(),
  z
    .object({
      chartFormat: z.literal('combo'),
      aggregation: comboChartAggregationSchema,
      design: comboChartDesignSchema,
    })
    .strict(),
])

export type KpiChartDisplaySettingPresetInput = z.infer<typeof kpiChartDisplaySettingPresetInputSchema>

// レスポンス用スキーマ（DB から読み出した settings + chartFormat カラムを再合成した形）
// 構造は Input と同一だが、用途を明確に分離する
export const kpiChartDisplaySettingPresetSettingsSchema = kpiChartDisplaySettingPresetInputSchema
export type KpiChartDisplaySettingPresetSettings = z.infer<typeof kpiChartDisplaySettingPresetSettingsSchema>
